<div class="header-container">
    <div class="mobile-view">
        <div class="mobile-container">
            <ccdl-brand
                [mobileSrc]="brandMobileSrc"
                [desktopSrc]="brandDesktopSrc"
                altText="Capvizon"
                [homeRoute]="brandHomeRoute"></ccdl-brand>
            <div class="user-name">{{accountName}}</div>
            <ccdl-menu-dropdown
                type="hamburger"
                name="M"
                showDropdown="true"
                [options]="mobileMenuOptions"
                (onClick)="selectedOption($event)">
            </ccdl-menu-dropdown>
        </div>
    </div>
    <div class="desktop-view">
        <div class="desktop-container">
            <div class="brand">
                <ccdl-brand
                    [mobileSrc]="brandMobileSrc"
                    [desktopSrc]="brandDesktopSrc"
                    altText="Capvizon"
                    [homeRoute]="brandHomeRoute"></ccdl-brand>
            </div>
            <div class="user-info">
                <ccdl-menu-dropdown
                    type="circle"
                    [showDropdown]="false"
                    name="M"
                    [showTextOnTop]="true"
                    [textOnTop]="messageTextOnTop"
                    (onClick)="selectedOption($event)"></ccdl-menu-dropdown>
                <ccdl-menu-dropdown
                    type="circle"
                    name="N"
                    [showTextOnTop]="true"
                    [textOnTop]="notificationTextOnTop"
                    [showDropdown]="true"
                    [dismissModal]="dismissModal"
                    (menuClick)="menuClick()"
                    (onClick)="selectedOption($event)">
                    <fm-notifications
                        [notifications]="notifications"
                        [isProcessing]="isAddContactProcessing"
                        [refreshKey]="dropdownMenuOpenKey"
                        (onContactDeclined)="onContactDeclined($event)"
                        (onContactAccepted)="onContactAccepted($event)"
                        (onLoadMoreNotifications)="onLoadMoreNotifications($event)"></fm-notifications>
                </ccdl-menu-dropdown>
                <ccdl-menu-dropdown
                    type="squircle"
                    [name]="accountName"
                    [menuText]="accountName | ccdlInitials"
                    [menuAccountId]="accountInfo?.custId"
                    showDropdown="true"
                    [options]="desktopMenuOptions"
                    (onClick)="selectedOption($event)">
                </ccdl-menu-dropdown>
            </div>
        </div>
    </div>
    <ccdl-divider></ccdl-divider>
</div>
